.shell{
  min-height:100dvh;
  color:#fff;
  background:
    radial-gradient(circle at 12% 18%,rgb(25 108 121 / 28%),transparent 28%),
    radial-gradient(circle at 78% 20%,rgb(70 119 148 / 22%),transparent 36%),
    linear-gradient(145deg,#0d3447 0%,#0e2b40 50%,#092237 100%);
}
.appBar{
  min-height:86px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:24px;
  padding:0 max(32px,calc((100vw - 1180px)/2));
  border-bottom:1px solid rgb(255 255 255 / 8%);
  background:linear-gradient(90deg,rgb(12 60 78 / 92%),rgb(8 48 72 / 88%));
  backdrop-filter:blur(18px);
}
.brand{display:flex;align-items:baseline;gap:10px;color:#fff;text-decoration:none;letter-spacing:.02em}
.brand strong{font-size:24px}
.brand span{color:var(--color-gold);font-size:10px;font-weight:800;letter-spacing:.22em}
.appActions{display:flex;align-items:center;gap:12px}
.homeButton,.menuButton{
  min-height:46px;border:1px solid rgb(255 255 255 / 14%);border-radius:18px;
  background:rgb(255 255 255 / 6%);color:#fff;text-decoration:none;
}
.homeButton{display:flex;align-items:center;gap:8px;padding:0 18px;font-weight:700}
.homeButton span{color:var(--color-gold);font-size:20px}
.menuButton{width:52px;font-size:19px;cursor:pointer}
.role{display:grid;padding-inline:4px 16px;border-left:1px solid rgb(255 255 255 / 12%)}
.role span,.roleAside span{font-size:9px;font-weight:800;letter-spacing:.12em;color:#8fb3c7}
.role strong,.roleAside strong{font-size:11px;color:#f4f7f9}
.hero{
  width:min(1180px,calc(100% - 40px));margin:0 auto;padding:54px 0 34px;
  display:flex;justify-content:space-between;gap:32px;align-items:center;
}
.eyebrow{margin:0 0 16px;color:var(--color-gold);font-size:11px;font-weight:800;letter-spacing:.16em}
.hero h1{max-width:760px;margin:0;font-size:clamp(38px,5vw,64px);line-height:1.04;letter-spacing:-.045em}
.hero h1 span{white-space:nowrap}
.roleAside{display:grid;gap:3px;min-width:250px}
.status{
  width:min(1180px,calc(100% - 40px));margin:0 auto 18px;padding:14px 18px;border:1px solid rgb(255 255 255 / 12%);
  border-radius:18px;background:rgb(255 255 255 / 6%);backdrop-filter:blur(18px);color:#d5e0e6;
}
.status strong,.status span{display:block}.status span{margin-top:3px}
.moduleGrid{
  width:min(1180px,calc(100% - 40px));margin:0 auto;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;
}
.moduleCard{
  position:relative;display:flex;align-items:flex-end;min-height:220px;overflow:hidden;border-radius:28px;
  border:1px solid rgb(87 167 192 / 30%);text-decoration:none;color:#fff;background-size:cover;background-position:center;
  box-shadow:0 22px 48px rgb(1 12 21 / 24%);transition:transform .18s ease,border-color .18s ease;
}
.moduleCard:hover{transform:translateY(-2px);border-color:rgb(191 173 129 / 48%)}
.moduleShade{position:absolute;inset:0;background:linear-gradient(90deg,rgb(3 18 30 / 78%),rgb(3 18 30 / 25%) 62%,rgb(3 18 30 / 14%)),linear-gradient(to top,rgb(3 18 30 / 58%),transparent 60%)}
.moduleCopy{position:relative;z-index:1;padding:28px;max-width:78%}
.moduleCopy h2{margin:0;font-size:clamp(30px,3vw,44px);letter-spacing:-.045em}
.moduleCopy p{margin:6px 0 0;color:#d7e2e8;font-size:14px;line-height:1.45}
.workspaces{background-image:url("https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1500&q=84")}
.network{background-image:url("https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1500&q=84")}
.collections{background-image:url("https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1500&q=84")}
.agency{background-image:url("https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1500&q=84")}
.businessCard{background-image:url("https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1500&q=84")}
.admin{background-image:url("https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1500&q=84")}
.quietSummary{
  width:min(1180px,calc(100% - 40px));margin:20px auto 0;display:flex;gap:8px;flex-wrap:wrap;
}
.quietSummary span{
  padding:8px 12px;border:1px solid rgb(255 255 255 / 10%);border-radius:999px;background:rgb(255 255 255 / 5%);
  color:#aec3cf;font-size:12px;
}
.footer{
  width:min(1180px,calc(100% - 40px));margin:0 auto;padding:28px 0 34px;display:flex;justify-content:space-between;align-items:center;
  color:#8fa7b6;font-size:12px;
}
.footer button{border:0;background:transparent;color:#bfad81;cursor:pointer}
.footer button:disabled{opacity:.5;cursor:wait}
.moduleCard:focus-visible,.homeButton:focus-visible,.menuButton:focus-visible,.footer button:focus-visible{outline:3px solid #bfad81;outline-offset:3px}
@media(max-width:760px){
  .appBar{min-height:72px;padding:0 16px}.brand strong{font-size:20px}.brand span{display:none}.role{display:none}.homeButton{padding:0 12px}.homeButton{font-size:0}.homeButton span{font-size:20px}
  .hero{width:calc(100% - 28px);padding:38px 0 24px;align-items:flex-start;flex-direction:column}.hero h1{font-size:42px}.roleAside{min-width:0}
  .moduleGrid{width:calc(100% - 28px);grid-template-columns:1fr;gap:14px}.moduleCard{min-height:190px;border-radius:24px}.moduleCopy{max-width:88%;padding:22px}.moduleCopy h2{font-size:34px}
  .quietSummary,.footer,.status{width:calc(100% - 28px)}.quietSummary{overflow-x:auto;flex-wrap:nowrap}.quietSummary span{flex:0 0 auto}
}
@media(prefers-reduced-motion:reduce){.moduleCard{transition:none}}
